import { Box, styled as muiStyled } from '@mui/material';

export const ContrastSliderTitleAndResetIcon = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
